// added for test

export default [
  {
    oem: 'VW',
    dealers: [
      '401015 Patrick Motors',

      '401016 Kelly Volkswagen',

      '401017 Colonial Volkswagen',

      '401023 Colonial Volkswagen of Medford',

      '401025 Tracy Volkswagen, Inc.',

      '401057 Minuteman Volkswagen, Inc.',

      '401065 Coastal Volkswagen',

      '401078 Fathers & Sons, Inc.',

      '401079 Quirk Volkswagen',

      '401080 Boston Volkswagen',

      '401127 Noyes Volkswagen, Inc.',

      '401128 Quirk Volkswagen NH',

      '401306 Shearer VW of South Burlington',

      '401313 Walker Volkswagen',

      '402132 The Autobarn Volkswagen of Evanston',

      '402147 Bill Jacobs Volkswagen',

      '402163 Hawk Volkswagen of Joliet',

      '402165 Volkswagen of Downtown Chicago',

      '402407 Rochester Volkswagen',

      '403112 Ganley Westside Volkswagen',

      '403128 Ganley Volkswagen of Bedford',

      '403139 Joseph Volkswagen of Cincinnati',

      '403143 Brunswick Volkswagen',

      '403163 White-Allen Volkswagen',

      '403192 Kempthorn Volkswagen',

      '403195 Bill Marine Auto Center, Inc.',

      '403196 Volkswagen of Perrysburg',

      '403200 Byers Imports, LLC',

      '403207 Fairfield Volkswagen',

      '406401 Young Volkswagen, Inc.',

      '406416 Kelly Volkswagen',

      '406419 Volkswagen Reading',

      '406445 J. Bertolet, Inc.',

      '406449 Autohaus Lancaster, Inc.',

      '406461 York Volkswagen, Inc.',

      '406482 Wynn Volkswagen',

      "406497 Jeff D'Ambrosio Volkswagen",

      '406502 Fairfield Volkswagen',

      '406506 Piazza Volkswagen of Ardmore',

      '406521 Fiore Volkswagen',

      '406528 Jack Metzer Volkswagen',

      '406529 Chapman Volkswagen',

      '406530 Colonial Volkswagen, Inc.',

      '406532 Faulkner Volkswagen  Mechanicsburg',

      '406534 Volkswagen of Newtown Square',

      '407211 Nalley Volkswagen of Alpharetta',

      '407218 Jim Ellis Volkswagen of Chamblee',

      '407229 Jim Ellis Volkswagen of Kennesaw',

      '407239 Stone Mountain Volkswagen',

      '407458 Hallmark Volkswagen at Cool Springs',

      '408062 Prestige Volkswagen of Stamford',

      '408080 Volkswagen of Old Saybrook',

      '408091 Danbury Volkswagen',

      '408104 Ide Volkswagen of East Rochester',

      "408123 Donaldson's, Inc.",

      '408139 Romano Volkswagen of Fayetteville',

      '408145 Volkswagen of Orchard Park',

      '408148 Burdick Volkswagen',

      '408160 Platinum Volkswagen',

      '408203 Gensinger Motors, Inc.',

      '408209 Reydel Volkswagen, Inc.',

      '408212 Burlington Volkswagen, Inc.',

      '408221 Open Road Volkswagen of Bridgewater',

      '408223 Volkswagen of Union',

      '408227 Toms River Volkswagen',

      '408228 Three County Volkswagen Corp.',

      '408230 Trend Motors, Ltd.',

      '408252 Jack Daniels Volkswagen',

      '408269 Joe Heidt Motors, Corp.',

      '408272 Linden Volkswagen',

      '408278 Cherry Hill Volkswagen',

      '408283 Atlantic Volkswagen',

      '408287 Flemington Volkswagen',

      '408303 Basil Volkswagen of Lockport',

      '408308 Long Island City Volkswagen',

      '408310 Open Road Volkswagen Manhattan',

      '408313 Garvey Volkswagen of Queensbury',

      '408321 Towne Volkswagen',

      '408330 Atlantic Volkswagen',

      '408340 Lash Volkswagen of White Plains',

      '408353 Smithtown Volkswagen',

      '408358 Fuccillo Volkswagen of Schenectady',

      '408366 Cooley Motors Corp.',

      '408382 Volkswagen of Huntington',

      '408396 Nemer Volkswagen',

      '409258 Volkswagen of South Charlotte',

      '409460 Lindsay Volkswagen of Dulles',

      '409514 Moses Volkswagen of Huntington',

      '409521 Wheeling Volkswagen',

      '422104 Puente Hills Volkswagen',

      '422110 Pacific Volkswagen',

      '422116 Volkswagen Pasadena',

      '422151 Volkswagen of Downtown LA',

      '422234 Chapman Volkswagen',

      '422503 Volkswagen Santa Monica, L.L.C.',

      '422530 Volkswagen Alhambra',

      "425018 Bobby Beck's Lewisville Volkswagen",

      '425030 Clay Cooley VW of Richardson',

      '425083 Clay Cooley VW of Park Cities',

      '425106 Metro Volkswagen',

      '425145 Hiley Volkswagen of Arlington',

      '425156 Rusty Wallis Volkswagen',

      '425157 Autobahn Motorcar Group',

      '425168 McKinney Volkswagen',

      '425169 Hendrick Volkswagen Frisco',

      '425171 Southwest Volkswagen of Weatherford',

      '425355 Owens-Murphy Volkswagen',

      '425651 Volkswagen of Lake Charles',

      '409221 Leith VW Raleigh',

      '409220 Leith VW Cary',

      '408234 Volkswagen World of Newton'
    ]
  },
  {
    oem: 'Jaguar',
    dealers: [
      'J5323 Jaguar Nashville',

      'J5326 Jaguar Reno',

      'J5330 Jaguar Jacksonville',

      'J5332 Jaguar Southampton',

      'J5333 Jaguar Huntington',

      'J5339 Jaguar Monmouth',

      'J5341 Jaguar Las Vegas',

      'J5359 Jaguar Northfield',

      'J5363 Jaguar Troy',

      'J5364 Jaguar Manhattan',

      'J5370 Jaguar Englewood',

      'J5372 Jaguar Glen Cove',

      'J5382 Jaguar Little Rock',

      'J5742 Jaguar Freeport'
    ]
  },
  {
    oem: 'Land Rover',
    dealers: [
      'LRNC0289 Land Rover Des Moines',

      'LRNC0635 Land Rover Englewood',

      'LRNC0606 Land Rover Freeport',

      'LRNC0603 Land Rover Glen Cove',

      'LRNC0602 Land Rover Huntington',

      'LRNC0395 Land Rover Jacksonville',

      'LRNC0252 Land Rover Las Vegas',

      'LRNC0627 Land Rover Manhattan',

      'LRNC0609 Land Rover Monmouth',

      'LRNC0150 Land Rover Nashville',

      'LRNC0225 Land Rover Northfield',

      'LRNC0350 Land Rover Omaha',

      'LRNC0621 Land Rover Paramus',

      'LRNC0383 Land Rover Reno',

      'LRNC0188 Land Rover Solon',

      'LRNC0601 Land Rover Southampton',

      'LRNC0620 Land Rover Troy',

      'LRNC0384 Land Rover Virginia Beach'
    ]
  },
  {
    oem: 'Land Rover Used',
    dealers: [
      'R0289 Land Rover Des Moines',

      'R0635 Land Rover Englewood',

      'R0606 Land Rover Freeport',

      'R0603 Land Rover Glen Cove',

      'R0602 Land Rover Huntington',

      'R0395 Land Rover Jacksonville',

      'R0395 Land Rover Jacksonville',

      'R0252 Land Rover Las Vegas',

      'R0627 Land Rover Manhattan',

      'R0609 Land Rover Monmouth',

      'R0150 Land Rover Nashville',

      'R0225 Land Rover Northfield',

      'R0350 Land Rover Omaha',

      'R0621 Land Rover Paramus',

      'R0383 Land Rover Reno',

      'R0188 Land Rover Solon',

      'R0601 Land Rover Southampton',

      'R0620 Land Rover Troy',

      'R0384 Land Rover Virginia Beach'
    ]
  },
  {
    oem: 'CDJR',
    dealers: [
      '23122 Salerno Duane, Inc.',

      '26778 Sansone Chrysler Jeed Dodge',

      '44740 Chrysler Jeed Dodge of Paramus',

      '60788 Chrysler Jeed Dodge Ram FIAT Manhattan',

      '60796 Chrysler Jeed Dodge Ram of Englewood Cliffs'
    ]
  },
  {
    oem: 'Honda',
    dealers: [
      { dealer: '208337 Atlantic Honda', email: 'sstrauch@aagny.net' },

      { dealer: '207164 Bay Ridge Honda', email: 'arianat@bayridgecars.com' },

      { dealer: '206788 Hillside Honda', email: 'awilliams@hillsidehonda.com' },

      { dealer: '208362 DCH Temecula', email: 'KColson@DCHUSA.com' }
    ]
  },
  {
    oem: 'Toyota',
    dealers: [
      '31173 Advantage Toyota',

      '04990 DCH Toyota of Oxnard',

      '37142 Fiore Toyota',

      '04774 Lodi Toyota',

      '04102 Toyota of Hollywood',

      '04303 Toyota Santa Monica',

      '29114 Toyota World of Clinton',

      '29095 Toyota World of Lakewood',

      '29100 Toyota World of Newton'
    ]
  }
];



// WEBPACK FOOTER //
// ./src/screens/Presentation/CoopDealersList.js